import * as React from "react";
import styled, { css } from "styled-components";
const BackgroundColor = styled.span(
  ({ theme, $color }) => css`
    background-color: ${$color};
    color: ${theme.utils.contrastingColor($color)};
    width: fit-content;
  `
);
const Highlight = ({ children = void 0, color }) => /* @__PURE__ */ React.createElement(BackgroundColor, { $color: color }, children);
export default Highlight;
